import { IBuyCarMenuPcCondition } from "@Types/buyCarMenu";
import { useSetState } from "ahooks";
import React from "react";

function finedBrandName(data: any, brandId: any) {
  let name = "";
  data.map((item: any) =>
    item.items.map((item: any) => {
      if (item.value == brandId) {
        name = item.name;
      }
    }),
  );
  return name;
}

const Item: React.FC<any> = ({ data, onChange, action }) => {
  return (
    <>
      {data.map((item, index: number) => (
        <div
          id='brandItem'
          data-id={item.value}
          className={`${
            action === `${item.value}` ? "bg-[#4364FF] text-white" : ""
          } cursor-pointer px-6  rounded-4 h-30 flex items-center justify-center`}
          onClick={() => onChange(item, { name: "brandIdName", value: "brandId" })}
          key={index}
        >
          {item.enName}
        </div>
      ))}
    </>
  );
};

const MoreBrandItem: React.FC<{
  item: IBuyCarMenuPcCondition["allBrand"][0];
  onChange: (items: any, keys: any) => void;
}> = ({ item, onChange }) => {
  const { items, label } = item;

  return (
    <div className='flex gap-14 mt-20'>
      <div className='text-primary w-10 text-center'>{label}</div>
      <div className='flex gap-x-20 gap-y-6 flex-wrap'>
        {items.map((item: any, index: number) => (
          <div
            id='brandItem'
            className='whitespace-pre cursor-pointer'
            key={index}
            data-id={item.value}
            onClick={() => onChange(item, { name: "brandIdName", value: "brandId" })}
          >
            {item.name}
          </div>
        ))}
      </div>
    </div>
  );
};

const MoreBrand: React.FC<{ data: IBuyCarMenuPcCondition["allBrand"]; onChange: (items: any, keys: any) => void }> = ({
  data,
  onChange,
}) => {
  return (
    <div
      className='px-14 pb-14 flex gap-18 mt-10'
      style={{ borderTop: "1px solid #E8E8E8", borderBottom: "1px solid #E8E8E8" }}
    >
      <div className='flex-1'>
        {data.map((item, index: number) => index < 9 && <MoreBrandItem key={index} item={item} onChange={onChange} />)}
      </div>
      <div className='flex-1'>
        {data.map((item, index: number) => index >= 9 && <MoreBrandItem key={index} item={item} onChange={onChange} />)}
      </div>
    </div>
  );
};

interface IBrandList {
  data: IBuyCarMenuPcCondition;
  onChange: (items: any, keys: any) => void;
  params: any;
}
const BrandList: React.FC<IBrandList> = ({ data, onChange, params }) => {
  const { brand, allBrand } = data;

  const { brandId } = params;
  const [query, setQuery] = useSetState({
    moreBrand: false,
  });
  const { moreBrand } = query;

  return (
    <div id='BrandList'>
      <div className='flex rounded-tr-4 rounded-tl-4  overflow-hidden'>
        <div
          className='w-90 bg-[#F0F6FF] text-14 px-18 whitespace-pre'
          style={{ textAlignLast: "justify", lineHeight: "46px" }}
        >
          廠牌
        </div>
        <div className='w-840 bg-white'>
          <div className='flex gap-8 items-center flex-wrap h-46 ml-12'>
            {brand.length > 0 && <Item onChange={onChange} data={brand} action={brandId} />}
            <div
              className={`cursor-pointer px-6  rounded-4 h-30 flex items-center justify-center select-none`}
              onClick={() => {
                setQuery({ moreBrand: !moreBrand });
              }}
            >
              {moreBrand ? "收起" : "更多"}
            </div>
          </div>
          {!!brandId && !brand.some((item: any) => `${item.value}` === brandId) && (
            <div
              className={`bg-[#4364FF] text-white cursor-pointer px-6  rounded-4 h-30  items-center justify-center ml-14 inline-flex`}
            >
              {finedBrandName(allBrand, brandId)}
            </div>
          )}
          {moreBrand && (
            <MoreBrand
              data={allBrand}
              onChange={(items, keys) => {
                onChange(items, keys);
                setQuery({ moreBrand: !moreBrand });
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default BrandList;
